export default "__VITE_ASSET__705cb72c__"